import { Link } from 'react-router-dom';
import SectionWave from '../components/SectionWave';
import ClosedDays from '../components/ClosedDays';
import SEO from '../components/SEO';
import './Home.css';

import imgHero from '../assets/IMG_8447-4-2048x1536.jpg';
import imgKlatring from '../assets/IMG_5002-700x700.jpg';
import imgSmaBorn from '../assets/IMG_4296-scaled.jpg';
import imgFest from '../assets/9CB44144-24CD-461B-9E29-E35FF36D1A90-scaled.jpeg';
import imgCandyBar from '../assets/C62D1782-7C47-43A1-89E6-1F27C7DB5CEE.jpeg';
import imgHoppe from '../assets/IMG_2051-1536x2048.jpg';

const hours = ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'];

export default function Home() {
  return (
    <main className="home">
      <SEO
        path="/"
        description="Little-Stars er et indendørs legeland og familieunivers i Randers NV. Legeområder for 0–10 år, ammerum, puslerum, minicafé og lokaleudlejning til fester. Åbent alle ugens dage 06–21."
      />

      {/* ── HERO ── */}
      <section className="hero">
        <img src={imgHero} alt="Little-Stars legeområde" className="hero-img" />
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1 className="hero-title">
            Magiske stunder<br />
            <span className="hero-accent">for store og små</span>
          </h1>
          <p className="hero-sub">
            Legeområde · Events · Minicafé · Ammerum · Puslerum
          </p>
          <div className="hero-actions">
            <Link to="/priser" className="btn btn-primary btn-lg">Se priser</Link>
            <Link to="/bliv-medlem" className="btn btn-white btn-lg">Bliv medlem</Link>
          </div>
        </div>
        <div className="hero-scroll-hint">
          <div className="scroll-arrow" />
        </div>
      </section>

      {/* ── NOTICE ── */}
      <section className="notice-section">
        <div className="container">
          <div className="notice-card">
            <span className="notice-icon">🔑</span>
            <div className="notice-text">
              <strong>Køb billet på forhånd</strong>
              <p>Få en kode til vores dør - ingen ventetid. Få 20% rabat med Randers Regnskov årskort.</p>
            </div>
            <Link to="/priser" className="btn btn-primary">Køb billet</Link>
          </div>
        </div>
      </section>

      <SectionWave color="#ffffff" />

      <ClosedDays />

      <SectionWave color="#f7f8fc" />

      {/* ── PLAY AREAS ── */}
      <section className="play-section">
        <div className="container">
          <div className="section-header">
            <div>
              <div className="section-label">Vores legeområder</div>
              <h2 className="section-title">Noget for <span className="gradient-text">alle aldre</span></h2>
            </div>
            <Link to="/faciliteter" className="btn btn-outline">Se alle faciliteter →</Link>
          </div>

          <div className="play-grid">

            <div className="play-img-card">
              <img src={imgSmaBorn} alt="De mindste leger" />
              <div className="play-img-label">
                <span className="play-age-tag">0–3 år</span>
                <h3>De mindste</h3>
                <p>Rolige områder med sansestimulering</p>
              </div>
            </div>

            <div className="play-img-card tall">
              <img src={imgKlatring} alt="Klatrestruktur" />
              <div className="play-img-label">
                <span className="play-age-tag">4+ år</span>
                <h3>Aktiv leg</h3>
                <p>Klatring, rutsjebaner og hoppeborg</p>
              </div>
            </div>

            <div className="play-img-card">
              <img src={imgHoppe} alt="Hoppeborg" />
              <div className="play-img-label">
                <span className="play-age-tag">Alle aldre</span>
                <h3>Hoppeborg</h3>
                <p>Masser af energi og grin</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SectionWave color="#f7f8fc" />

      {/* ── HOURS + RENTAL ── */}
      <section className="hours-section">
        <div className="container hours-container">

          <div className="hours-content">
            <div className="section-label">Åbningstider</div>
            <h2 className="section-title">Åbent <span className="gradient-text">alle ugens dage</span></h2>
            <div className="hours-list">
              {hours.map(day => (
                <div className="hours-row" key={day}>
                  <span className="day">{day}</span>
                  <span className="dots" />
                  <span className="time">06.00–21.00</span>
                </div>
              ))}
            </div>
            <p className="hours-note">
              ⚠️ Afdeling 1 lukker kl. 14 dagen før en udlejning og er lukket hele dagen på selve udlejningsdagen. Afdeling 2 har altid åbent.
            </p>
          </div>

          <div className="rental-block">
            <div className="rental-imgs">
              <img src={imgFest} alt="Festlokale" className="rental-img-main" />
              <img src={imgCandyBar} alt="Candy bar" className="rental-img-side" />
            </div>
            <div className="rental-text">
              <div className="section-label">Lokaleudlejning</div>
              <h3>Lej til din næste fest</h3>
              <p>
                Hele Little-Stars afdeling 1 for jer selv - perfekt til børnefødselsdage og fester.
                Fra én dag til en hel weekend.
              </p>
              <p>
                Du er altid velkommen til at skrive til os, selv hvis datoen allerede er booket, så kontakter vi dig ved afbud.
              </p>
              <div className="rental-actions">
                <Link to="/priser" className="btn btn-primary">Se priser</Link>
                <a href="mailto:booking@little-stars.dk" className="btn btn-outline">Book her</a>
              </div>
            </div>
          </div>

        </div>
      </section>

      <SectionWave color="#ffffff" flip />


      <SectionWave color="#f7f8fc" />

      {/* ── FIND US ── */}
      <section className="findus-section">
        <div className="container findus-container">
          <div>
            <div className="section-label">Find os</div>
            <h2 className="section-title">Kom og <span className="gradient-text">besøg os</span></h2>
            <div className="address-list">
              {[
                { icon: '📍', label: 'Adresse', val: 'Hovedvejen 8, 8920 Randers NV' },
                { icon: '🚗', label: 'Parkering', val: 'Gratis parkering foran hoveddøren' },
                { icon: '🚌', label: 'Bus', val: 'Bus nr. 230 stopper næsten lige udenfor' },
                { icon: '🍼', label: 'Barnevogn', val: 'Plads til barnevogne udenfor' },
              ].map(r => (
                <div className="address-row" key={r.label}>
                  <span className="addr-icon">{r.icon}</span>
                  <div>
                    <strong>{r.label}</strong>
                    <p>{r.val}</p>
                  </div>
                </div>
              ))}
            </div>
            <a
              href="https://maps.google.com/?q=Hovedvejen+8,+8920+Randers+NV"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
              style={{ marginTop: '1.5rem' }}
            >
              Åbn i Maps
            </a>
          </div>

          <div className="map-placeholder">
            <iframe
              src="https://maps.google.com/maps?q=Hovedvejen%208%2C%208920%20Randers%20NV&z=15&output=embed"
              title="Kort over Little-Stars, Hovedvejen 8, 8920 Randers NV"
              className="map-frame"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>


    </main>
  );
}
